import { Link, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import AddAssetsModal from "./AddAssetsModal";

export default function Assets() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [showAssetsModal, setShowAssetsModal] = useState(false);
  const toggleAddAssetsModal = () => { setShowAssetsModal(!showAssetsModal) }
  const [modalData, setModalData] = useState({});
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    assetsData: [],
    searchQuery: "",
  });

  useEffect(() => {
    GetAssetsList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates.pageSize]);

  const GetAssetsList = (pageNumber) => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_asset + "?" + MainFilterHandler(pageStates);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        // const newData = response?.data?.customer?.map((item) => ({
        //   ...item,
        //   firm: item?.name,
        //   email: item?.email,
        //   phone: item?.phone || "-",
        //   address: item?.address,
        // gstNumber: item?.gstNumber
        // }))
        setPageStates((prevStates) => ({
          ...prevStates,
          assetsData: response.data?.asset,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id)
    toggle();
  }

  const HandleUpdate = (data) => {
    setModalData(data);
    toggleAddAssetsModal();
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_asset + `?assetId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetAssetsList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Asset Name" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      clickHandler: ActionHandler,
    },
  ];


  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Assets"}
            buttonText={"Add Assets"}
            buttonIcon={<PlusIcon />}
            clickHandler={() => {
              setModalData({});
              toggleAddAssetsModal()
            }}
          />
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent handleSearch={handleSearchChange} />
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.assetsData}
                ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
              />
            </div>
          </div>
        </div>
      </>
      <AddAssetsModal
        modal={showAssetsModal}
        toggle={toggleAddAssetsModal}
        modalData={modalData}
        GetAssetsList={GetAssetsList}
      />
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
